import { render, staticRenderFns } from "./OwnersListTableRowItem.vue?vue&type=template&id=51c31840&scoped=true&"
import script from "./OwnersListTableRowItem.vue?vue&type=script&lang=js&"
export * from "./OwnersListTableRowItem.vue?vue&type=script&lang=js&"
import style0 from "./OwnersListTableRowItem.vue?vue&type=style&index=0&id=51c31840&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51c31840",
  null
  
)

export default component.exports